<section class="why-choose-us" [class.visible]="isVisible">
  <div class="container">
    <div class="custom-section-title">
      <span class="eyebrow">Why Choose Us</span>
      <h2 class="title">Your Full-Service Expert Yacht Brokerage</h2>
    </div>

    <div class="features-grid">
      <app-glass-card *ngFor="let feature of features; let i = index" intensity="light" [interactive]="true"
        [style.transition-delay]="i * 100 + 'ms'" [style.--card-bg]="'url(' + feature.image + ')'">
        <div class="feature-item">
          <div class="icon-wrapper">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round">
              <path [attr.d]="feature.icon" />
            </svg>
          </div>
          <h3>{{ feature.title }}</h3>
          <p>{{ feature.description }}</p>
        </div>
      </app-glass-card>
    </div>
  </div>
</section>
